import { Button, Modal, Text } from "../../components";
import { SVGs } from "../../assets";
import type { PaymentSuccessViewModel } from "./viewModel";

export type PaymentSuccessViewProps = PaymentSuccessViewModel;

export default function PaymentSuccessView(props: PaymentSuccessViewProps) {
  const { t } = props;
  return (
    <Modal ref={props.modalRef} canClose={false}>
      <div className="grid justify-items-center text-center">
        <div
          ref={props.printTargetRef}
          className="flex flex-col items-center gap-[40px]"
        >
          <img src={SVGs.successCheck} alt="" className="w-[100px] h-[100px]" />
          <Text level={1}>{t("paymentSuccess.bookingConfirmed")}</Text>
          <div className="px-[40px] text-center space-y-[8px]">
            <Text level={4}>
              <Text className="font-normal" as="span" level={4}>
                {t("paymentSuccess.bookingId")}{" "}
              </Text>
              {`#${props.code}`}
            </Text>
            <Text level={4}>{t("paymentSuccess.confirmationEmailsSent")}</Text>
          </div>

          <div className="w-full grid gap-[16px] text-left">
            {props.checklistKeys.map((key) => (
              <div key={key} className="flex items-start gap-[12px]">
                <img
                  src={SVGs.check}
                  alt=""
                  className="w-[18px] h-[18px] mt-[3px]"
                />
                <Text className="text-text-secondary">{t(key)}</Text>
              </div>
            ))}
          </div>
        </div>
        <div className="w-full grid grid-cols-2 gap-[16px] mt-[40px]">
          <Button
            color="secondary"
            className="w-full"
            onClick={props.printConfirmation}
          >
            {t("paymentSuccess.printConfirmation")}
          </Button>
          <Button
            color="primary"
            className="w-full"
            onClick={() => props.close()}
          >
            {t("paymentSuccess.startNewBooking")}
          </Button>
        </div>
      </div>
    </Modal>
  );
}
